<template>
    <signup />
</template>

<script>
export default {
    components: {
        'signup': () => import('@/components/signup')
    }

}
</script>

<style>

</style>
